import PageContainer from "../../components/layout/PageContainer";
import SettingsProfileForm from "../../components/settings/SettingsProfileForm";
import { useSettings } from "../../hooks/useSettings";
import Settings from "../Settings";

const ProfileSettings = () => {
  const { user, isSavingProfile, updateProfile } = useSettings();

  return <Settings />;
};

export default ProfileSettings;
